module.exports = __webpack_public_path__ + "img/down-neimeng1.5ce2cee8.jpg";